module.exports = __webpack_public_path__ + "static/img/part2.b6564b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/part2.png
// module id = IWxZ
// module chunks = 0